import React from "react";
import { FormControlLabel } from "@mui/material";

import "./SavePageView.scss";
import { Typography, Checkbox } from "cprime-foundational-components";
export interface Dashboard {
  view_name: string;
  createdAt: string;
  is_pinned: boolean;
  isFav?: boolean;
  is_default?: boolean;
  id: string;
  seqNo?: number;
  userId: number;
  gridName: string;
  viewData: any;
  viewOrder: number;
  viewBy: string;
}

interface FormData {
  cDashboardName: string;
  is_default: boolean;
  error: string;
}

interface SaveAsProps {
  formData: FormData;
  setFormData: React.Dispatch<React.SetStateAction<FormData>>;
  savedViews: Dashboard[];
  editingViewId?: number | null;
  isEditing?: boolean;
}

const SaveAs: React.FC<SaveAsProps> = ({
  formData,
  setFormData,
  savedViews,
  editingViewId = null,
  isEditing = false,
}) => {
  const handleDashboardNameChange = (
    e: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const value = e.target.value;
    const viewExists = savedViews.some((view) => {
      const currentId = Number(view.seqNo ?? view.id);
      if (editingViewId !== null && currentId === editingViewId) {
        return false;
      }

      return value.trim().toLowerCase() === view.view_name.trim().toLowerCase();
    });

    setFormData((prev) => {
      const updatedFormData = {
        ...prev,
        cDashboardName: value,
        error: viewExists
          ? "You already have a view with this name. Please check."
          : "",
      };
      return updatedFormData;
    });
  };

  const handleDefaultChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const checked = e.target.checked;
    setFormData((prev) => ({
      ...prev,
      is_default: checked,
    }));
  };

  return (
    <div className="saved-page-view">
      <div className="description">
        <Typography variant="body2" className="description-text">
          {isEditing ? "Editing" : "Saving"} a page view allows you to easily
          access your filter configurations from within the{" "}
          <span className="highlighted">Saved Page View</span> dropdown.
        </Typography>
        <Typography variant="body2" className="description-text">
          To edit or delete existing saved filters, select{" "}
          <span className="highlighted">Manage Saved Page Views</span>.
        </Typography>
      </div>

      <div className="dashboard-name-field-wrap">
        <input
          className="cDashboardName"
          name="cDashboardName"
          value={formData.cDashboardName}
          placeholder={isEditing ? "Rename saved view" : "My custom dashboard"}
          onChange={handleDashboardNameChange}
          aria-label="Dashboard name"
        />
        {formData.error !== "" && (
          <div className="dashboard-name-error">{formData.error}</div>
        )}
      </div>

      <FormControlLabel
        sx={{ ml: "0px" }}
        control={
          <Checkbox
            name="is_default"
            checked={formData.is_default}
            onChange={handleDefaultChange}
          />
        }
        label={
          <Typography variant="body2">
            Make this page setting my default
          </Typography>
        }
      />
    </div>
  );
};

export default SaveAs;
